import React, { ReactElement, useState } from 'react';
import styles from './passwordInput.module.scss';
import classnames from 'classnames';
import * as _ from 'lodash';

interface PasswordProps {
    password: string;
    onChange: (password: string) => void;
    errors: string[] | undefined;
    handleSubmit: () => void;
    highlightError: boolean;
    disabled?: boolean;
}

const PasswordInput: React.FunctionComponent<PasswordProps> = ({
    password,
    onChange,
    errors,
    handleSubmit,
    highlightError,
    disabled,
}): ReactElement => {
    const [visibility, setVisibility] = useState<boolean>(false);

    const setPasswordVisibility = (newVisibility: boolean): void => {
        setVisibility(newVisibility);
    };

    const onKeyPress = async (event: React.KeyboardEvent<HTMLInputElement>): Promise<void> => {
        if (event.key === 'Enter') {
            return handleSubmit();
        }
    };

    const hasErrors = !_.isEmpty(errors);

    return (
        <>
            <div
                className={classnames(
                    { [styles.errorPasswordInputGroup]: highlightError || hasErrors },
                    styles.passwordInputGroup
                )}
            >
                <label className={styles.inputLabel} htmlFor='password'>
                    Password
                </label>
                <div className={styles.passwordInputField}>
                    <input
                        id='password'
                        name='password'
                        className={classnames(
                            { [styles.errorInputField]: highlightError || hasErrors },
                            styles.inputField
                        )}
                        aria-describedby={'password-input-hint-text'}
                        type={visibility ? 'text' : 'password'}
                        value={password}
                        onChange={(event): void => onChange(event.target.value)}
                        onKeyPress={onKeyPress}
                        disabled={disabled}
                    />
                    <button
                        className={classnames(
                            { [styles.errorButton]: highlightError || hasErrors },
                            styles.showHideButton
                        )}
                        onClick={(): void => setPasswordVisibility(!visibility)}
                        data-ga={!visibility ? 'show-password' : 'hide-password'}
                        aria-live={'polite'}
                        aria-label={
                            !visibility
                                ? 'By clicking on this button, text typed in the password field will be displayed and will be spoken by screen readers'
                                : undefined
                        }
                        disabled={disabled}
                    >
                        {visibility ? 'Hide password' : 'Show password'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default PasswordInput;
